import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {LocaleService} from "../../../../services/locale.service";
import {Subscription} from "rxjs";
import {CoreModule} from "../../../core.module";
import {FooterLinkPipe} from "../../pipes/footer-link.pipe";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CoreModule, FooterLinkPipe]
})
export class FooterComponent implements OnInit, OnDestroy {
  public currentYear = new Date().getUTCFullYear();
  public currentLang: string = this.localeService.currentLocale;

  private localeChangedSubscription?: Subscription;

  public ngOnInit(): void {
    this.localeChangedSubscription = this.localeService.localeChanged.subscribe({
      next: (value: string) => {
        this.currentLang = value;
        this.cdr.markForCheck();
      }
    });
  }

  public ngOnDestroy() {
    this.localeChangedSubscription?.unsubscribe();
  }

  public langChange(lang: 'de' | 'en') {
    this.localeService.changeLocale(lang);

  }

  public constructor(
    private localeService: LocaleService,
    private cdr: ChangeDetectorRef
  ) {
  }
}
